import { type RefObject, useEffect, useState } from 'react';

export default function useTruncated(ref: RefObject<HTMLElement | null>, content?: string): boolean {
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const checkTruncation = () => {
      const truncated = element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
      setIsTruncated(truncated);
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);

    return () => {
      window.removeEventListener('resize', checkTruncation);
    };
  }, [content, ref]);

  return isTruncated;
}
